import "../css/index.js";import "./custom-script-6.js";